// IMPORTANT: CHECK UTILS/UI BEFORE ADDING TO THIS FILE TO AVOID DUPLICATING FUNCTIONS

// WORK IN PROGRESS
// PUBLISHER LIST

export const PID = {
  aps: '1083',
  ottera: '475',
  philo: '381',
  publica: '1',
  rarefiedAtmosphere: '408',
  roku: '437',
  samsungAU: '642',
  samsungBrazil: '643',
  samsungCA: '1030',
  samsungEU: '486',
  samsungIN: '744',
  samsungKorea: '547',
  samsungMENA: '1208',
  samsungMX: '654',
  samsungNA: '394',
  viacomCBS: '538',
  weatherNation: '1071',
};

export const PUBLICA_ID = '1';
export const isPublisherPublica = (publisherID: string) => publisherID === PID.publica;

const SAMSUNG_IDS = [
  PID.samsungAU,
  PID.samsungBrazil,
  PID.samsungCA,
  PID.samsungEU,
  PID.samsungIN,
  PID.samsungKorea,
  PID.samsungMENA,
  PID.samsungMX,
  PID.samsungNA,
];
export const isPublisherSamsungNA = (publisherID: string) => publisherID === PID.samsungNA;
export const isPublisherSamsung = (publisherID: string) => SAMSUNG_IDS.includes(publisherID);

// USED FOR PARENT OVERVIEW DASHBOARD
const PARENT_PUBLISHER_IDS = [PID.samsungNA, PID.samsungKorea, PID.roku, PID.ottera, PID.viacomCBS];
export const isPublisherParent = (publisherID: string) => {
  return PARENT_PUBLISHER_IDS.includes(publisherID);
};
